import type { LabelTemplate } from '../types'

export const LABEL_TEMPLATES: Record<string, LabelTemplate> = {
  avery5160: {
    id: 'avery5160',
    name: 'Avery 5160/8460',
    dimensions: '1" x 2-5/8"',
    labels_per_page: 30,
    labels_per_row: 3,
    label_rows: 10,
    page_width: 612,
    page_height: 792,
    label_width: 189,
    label_height: 72,
    label_margin_x: 7.2,
    label_margin_y: 1,
    left_margin: 13.5,
    top_margin: 54,
    horizontal_gap: 9,
    vertical_gap: 0,
  },
  averyl7160: {
    id: 'averyl7160',
    name: 'Avery L7160',
    dimensions: '63.5 x 38.1mm',
    labels_per_page: 21,
    labels_per_row: 3,
    label_rows: 7,
    page_width: 595.2,
    page_height: 841.8,
    label_width: 180,
    label_height: 108.75,
    label_margin_x: 7.2,
    label_margin_y: 7.2,
    left_margin: 20.551,
    top_margin: 52,
    horizontal_gap: 7.087,
    vertical_gap: 0,
  },
  'avery64x30-r': {
    id: 'avery64x30-r',
    name: 'Avery 64x30-R',
    dimensions: '64 x 30mm',
    labels_per_page: 27,
    labels_per_row: 3,
    label_rows: 9,
    page_width: 595.2,
    page_height: 841.8,
    label_width: 181.417,
    label_height: 85.039,
    label_margin_x: 7.2,
    label_margin_y: 7.2,
    left_margin: 20.551,
    top_margin: 45.869,
    horizontal_gap: 7.087,
    vertical_gap: 0,
  },
  averyj8158: {
    id: 'averyj8158',
    name: 'Avery J8158',
    dimensions: '64 x 26.7mm',
    labels_per_page: 30,
    labels_per_row: 3,
    label_rows: 10,
    page_width: 595.2,
    page_height: 841.8,
    label_width: 181.417,
    label_height: 76.5,
    label_margin_x: 7.2,
    label_margin_y: 7.2,
    left_margin: 20.551,
    top_margin: 47.5,
    horizontal_gap: 7.087,
    vertical_gap: 0,
  },
  averyl7157: {
    id: 'averyl7157',
    name: 'Avery L7157',
    dimensions: '64 x 24.3mm',
    labels_per_page: 33,
    labels_per_row: 3,
    label_rows: 11,
    page_width: 595.2,
    page_height: 841.8,
    label_width: 181.417,
    label_height: 69.75,
    label_margin_x: 7.2,
    label_margin_y: 7.2,
    left_margin: 20.551,
    top_margin: 47.5,
    horizontal_gap: 7.087,
    vertical_gap: 0,
  },
  avery94208: {
    id: 'avery94208',
    name: 'Avery 94208',
    dimensions: '2/3" x 1-3/4"',
    labels_per_page: 60,
    labels_per_row: 4,
    label_rows: 15,
    page_width: 612,
    page_height: 792,
    label_width: 126,
    label_height: 48,
    label_margin_x: 5.76,
    label_margin_y: 7.2,
    left_margin: 21.6,
    top_margin: 46,
    horizontal_gap: 21.6,
    vertical_gap: 0,
  },
}

export const DEFAULT_TEMPLATE_ID = 'avery5160'

export function getTemplate(id: string | null): LabelTemplate | undefined {
  if (!id) return undefined
  return LABEL_TEMPLATES[id]
}

export function getDefaultTemplate(): LabelTemplate {
  return LABEL_TEMPLATES[DEFAULT_TEMPLATE_ID]
}
